import Alpine from "alpinejs";
import Clipboard from '@ryangjchandler/alpine-clipboard';

import "./js/theme";
import "./js/alpine-store";
import "./js/alpine-money";
import './js/swiper';


/**
 * Grabs the value of a CSS variable
 * @param {string}  - Name of the CSS variable to grab.
 * @return {string} - Value of the CSS variable passed as an argument.
 */
window.getCSSVariableValue = function (variableName) {
    const value = getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
    // If the value is in rem, convert it to px
    if (value.includes('rem')) {
        const remValue = parseFloat(value);  // Get the numeric part of the value
        const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);  // Root font size (usually 16px)
        return remValue * rootFontSize;  // Convert to px
    }

    // If the value is already in px, return as is
    return parseFloat(value);  // Return the numeric part (e.g., for px values)
};

window.waitForElement = function(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

window.Alpine = Alpine;
Alpine.plugin(Clipboard);
Alpine.start();